'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBemReact = require('@yandex-lego/i-bem-react');

var _ticker__countReact = require('./__count/ticker__count.react.js');

var _ticker__countReact2 = _interopRequireDefault(_ticker__countReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TickerCount = _ticker__countReact2.default.applyDecls();

;
exports.default = (0, _iBemReact.decl)({
    block: 'ticker',
    tag: 'span',
    attrs: function attrs(_ref) {
        var title = _ref.count;

        return {
            title: title,
            role: 'alert',
            'aria-live': 'assertive',
            'aria-atomic': 'true'
        };
    },
    mods: function mods(_ref2) {
        var count = _ref2.count;

        return {
            state: count ? 'normal' : 'empty'
        };
    },
    content: function content(_ref3) {
        var url = _ref3.url,
            count = _ref3.count,
            maxCount = _ref3.maxCount;

        return _react2.default.createElement(TickerCount, { url: url, count: count, maxCount: maxCount });
    }
}, {
    propTypes: {
        url: _propTypes2.default.string,
        count: _propTypes2.default.number,
        maxCount: _propTypes2.default.number
    },
    defaultProps: {
        count: 0,
        maxCount: 99
    }
});